import { Typography } from '../../../src/types/types.js'
import { font } from './font.js'

export const typography: Typography = {
  id: 'plus-jakarta-sans',
  name: 'Plus Jakarta Sans',

  font,
}
